module.exports = "<div class=\"navbar-fixed-bottom footer\"> <span class=navbar-brand> <span class=poweredby>powered by</span><a href=https://www.gesundheitsforen.net><img src=/images/gfl-logo.small.png style=width:250px /></a> </span> <span class=versioninfo> <span>v{{$root.config.version}}</span> </span> <ul class=\"nav navbar-nav\"> <li><a ui-sref=main.downloads>Downloads</a></li> <li><a ui-sref=main.impressum>Impressum</a></li> <li ng-if=$root.user><a ui-sref=main.contact>Kontakt</a></li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/modules/app/components/footer/emil-footer.component.html
// module id = 356
// module chunks = 0